<script setup>
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';
import ImageComponent from '@/components/common/ImageComponent.vue';

const props = defineProps({
  textmessage: {
    type: Object,
    default: () => ({}),
  },
  previewType: {
    type: String,
    default: '',
  },
  position: {
    type: String,
    default: '',
  },
  fallback: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();
const {
  textmessage,
  fallback,
  previewType,
} = toRefs(props);

const imageUrl = computed(() => {
  if (previewType.value === 'fallback') {
    return fallback.value?.image?.url ?? '';
  }

  return textmessage.value?.image?.url ?? '';
});
const contentList = computed(() => {
  if (previewType.value === 'fallback') {
    return (fallback.value?.content || t('preview.content'))
      .split('\n')
      .map((v) => v || '\u00A0');
  }

  return (textmessage.value?.content || t('preview.content'))
    .split('\n')
    .map((v) => v || '\u00A0');
});

</script>
<template>
  <div class="preview-talk preview-talk--active">
    <div class="preview-inner mockup-scroll">
      <div class="preview-message text-message preview-message--active">
        <div
          class="preview-message__inner-img"
          :class="{
            'd-none': !imageUrl,
            editAreaPositionHover: position === 'image',
          }"
        >
          <ImageComponent
            :src="imageUrl"
            alt="MMS image"
          />
        </div>
        <div class="preview-message__inner">
          <div
            class="preview-message__inner-cont"
            :class="{ editAreaPositionHover: position === 'content', }"
          >
            <p
              v-for="(item, index) in contentList"
              :key="`previewContent${index}`"
            >{{ item }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
